import axios from 'axios';

const WRONG_API_KEY_ERROR = '401: Could not find user with that api key.';

const initialState = {
  isLoading: false,
  message: '',
  hasError: false,
  hasApiKeyError: false,
  integrationStatus: 'disconnected',
}

export default {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    setIsLoading(state, value) {
      state.isLoading = value;
    },
    setErrorMessage(state, message) {
      state.message = message;
      state.hasError = true;
    },
    resetErrorMessage(state) {
      state.message = '';
      state.hasError = false;
    },
    setIntegrationStatus(state, value) {
      state.integrationStatus = value;
    },
    setApiKeyError(state, value) {
      state.hasApiKeyError = value;
    },
  },
  actions: {
    async saveCmaApiKey({ commit }, apiKey) {
      try {
        commit('setIsLoading', true);
        await axios.post(`${process.env.VUE_APP_INTEGRATIONS}/cma/reports/connect`, {
          'api_key': apiKey,
        });
      }
      catch(error) {
        const { data } = error;
        commit('setErrorMessage', data.error);
      }
      finally {
        commit('setIsLoading', false);
      }
    },
    async getIntegrationData({ commit, rootState, dispatch }, forceUpdate = false) {
      try {
        commit('setIsLoading', true);
        if (!rootState.integrations.loaded || forceUpdate) {
          await dispatch('integrations/getIntegrations', null, { root: true });
        }
        let integrations = rootState.integrations.integrations;
        const integration = integrations.find(i => i.name === 'Cloud CMA Report');
        if (integration) {
          return commit('setIntegrationStatus', integration.status);
        }
        commit('setIntegrationStatus', 'disconnected');
      } catch(error) {
        const { data } = error;
        commit('setErrorMessage', data.error);
      } finally {
        commit('setIsLoading', false);
      }
    },
    async generateCmaReport({ commit }, { contactId, address, contactName }) {
      const payload = {
        contact_id: contactId,
        contact_name: contactName,
        full_address: address,
      };

      try {
        commit('setIsLoading', true);
        await axios.post(
          `${process.env.VUE_APP_INTEGRATIONS}/cma/reports`,
          payload,
        );
      } catch(error) {
        const { data } = error;

        if (data.error === WRONG_API_KEY_ERROR) {
          commit('setApiKeyError', true);
          return;
        }

        commit('setErrorMessage', data.error);
      } finally {
        commit('setIsLoading', false);
      }
    },
  },
}
